import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/index.css';

// Components
import PublicLayout from './components/PublicLayout';

// Context
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';

// Configuration
import APP_CONFIG from './config/appConfig';

function App() {
  const isAdminMode = APP_CONFIG.isAdminMode();

  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <PublicLayout />
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
